import apis from "../../../apis/api";

enum status {
    COMPLETED = "COMPLETED",
    STARTED = "STARTED",
    NOTSTARTED = "NOTSTARTED"
}
export interface IQuestionTxn {
    q_id: string,
    type: string,
    start_time: Date | string,
    completed_students: number,
    status: status,
    score: number,
    lo_id: string,
    reviewObj: any
}

export class LiveSession {
    sessionId: string;
    sessionNo: string;
    batchId: string;
    userId: string;
    baseKey: string = "session";
    sectionType: string = "rz";
    constructor(sessionId: string,
        sessionNo: string,
        batchId: string,
        userId: string,
    ) {
        this.sessionId = sessionId;
        this.sessionNo = sessionNo;
        this.batchId = batchId;
        this.userId = userId;
        this.baseKey += `_${this.sessionId}_${this.batchId}_${this.sessionNo}`;
    }

    getQuestionTxnKey(qId: string, loId: string): string {
        return `${this.baseKey}_ques_${this.sectionType}_${qId}_${loId}`;
    }

    async getQuestionTxn(question: { qId: string, loId: string }[]): Promise<IQuestionTxn[]> {
        const questionTxns: IQuestionTxn[] = [];

        for (let i = 0; i < question.length; i++) {
            const ques = question[i];
            const key = this.getQuestionTxnKey(ques.qId, ques.loId);
            const res = await apis._getSessionTxn(key);
            if (res.status === 200 && res.data &&
                res.data.keyData !== null &&
                res.data.keyData !== undefined &&
                res.data.keyData !== "") {
                questionTxns.push(res.data.keyData);
            }
            else {
                questionTxns.push({
                    q_id: ques.qId,
                    lo_id: ques.loId,
                    type: this.sectionType,
                    start_time: "",
                    completed_students: 0,
                    status: status.NOTSTARTED,
                    score: 0,
                    reviewObj: {}
                });
            }
        }

        return questionTxns;
    }

    async setQuestionTxn(questionTxn: IQuestionTxn): Promise<boolean> {
        const key = this.getQuestionTxnKey(questionTxn.q_id, questionTxn.lo_id);
        const res = await apis._setSessionTxnData(key, questionTxn);
        if (res.status === 200) {
            return true;
        }
        return false;
    }

    async getAllQuestionTxnKeys(): Promise<string[]> {
        const QKEY = `${this.baseKey}_ques`;
        const res = await apis._getAllSessionTxn(QKEY, this.sectionType);
        console.log(res);
        if (res.status === 200 && res.data &&
            res.data !== null &&
            res.data !== undefined && res.data.length > 0) {
            return res.data;
        }
        return [];
    }
}